/* 
  This script was created by ColorBox with AI and optimized by Lugus 
  Description: Displays product cards in the article content.
*/

(function() {
  // Step 1: Target the article content container
  const articleRoot = document.querySelector('.article__content.rte');
  if (!articleRoot) return;

  // Step 2: Prevent double execution (editor, re-renders, etc.)
  if (articleRoot.dataset.productShortcodesApplied === '1') return;
  articleRoot.dataset.productShortcodesApplied = '1';

  // Step 3: Regex pattern to match shortcode blocks
  // Matches: === Produit === (content) === Produit ===
  const shortcodeRegex = /===\s*Produit\s*===([\s\S]*?)===\s*Produit\s*===/gi;

  // Step 4: Transform content in a single pass (prevents duplicates)
  const originalHTML = articleRoot.innerHTML;
  const replacedHTML = originalHTML.replace(shortcodeRegex, (match, inner) => {
    const raw = (inner || '').trim();
    
    // Extract product handle from URL if present
    const urlMatch = raw.match(/\/products\/([^\/\?\#]+)/i);
    const handle = urlMatch && urlMatch[1]
      ? urlMatch[1]
      : (!/\s/.test(raw) && !/https?:\/\//i.test(raw) ? raw.toLowerCase() : '');
    
    return `<div class="product-shortcode" data-raw="${encodeURIComponent(raw)}"${handle ? ` data-handle="${handle}"` : ''}></div>`;
  });

  if (replacedHTML !== originalHTML) {
    // Create temporary container to replace only inner content
    const wrapper = document.createElement('div');
    wrapper.innerHTML = replacedHTML.trim();

    // Preserve the same structure as original content
    while (articleRoot.firstChild) {
      articleRoot.removeChild(articleRoot.firstChild);
    }
    articleRoot.append(...wrapper.childNodes);
  } else {
    // Nothing to replace, exit early
    return;
  }

  // Step 5: Hydrate placeholders -> product cards
  const blocks = articleRoot.querySelectorAll('.product-shortcode');

  /**
   * Fetch product data by handle from Shopify API
   * @param {string} handle - Product handle
   * @returns {Promise<Object>} Product data
   */
  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product not found');
    return await res.json();
  }

  /**
   * Search for product by title using Shopify search API
   * @param {string} title - Product title to search
   * @returns {Promise<Object|null>} Product data or null if not found
   */
  async function searchByTitle(title) {
    const url = `/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&resources[limit]=5`;
    const res = await fetch(url, {
      headers: { 'Accept': 'application/json' }
    });
    
    if (!res.ok) return null;
    
    const data = await res.json();
    const items = (data.resources?.results?.products) || [];
    
    if (!items.length) return null;
    
    // Try to find exact match first, otherwise return first result
    const exact = items.find(p => (p.title || '').toLowerCase() === title.toLowerCase());
    return exact || items[0];
  }

  // Process each shortcode block
  blocks.forEach(async (el) => {
    const raw = decodeURIComponent(el.getAttribute('data-raw') || '').trim();
    let handle = el.getAttribute('data-handle');

    try {
      let product;
      
      if (handle) {
        // Direct fetch by handle
        product = await fetchProduct(handle);
      } else {
        // Search by title, then fetch by handle
        const found = await searchByTitle(raw);
        if (!found) throw new Error('No product found');
        
        const urlMatch = found.url?.match(/\/products\/([^\/\?\#]+)/i);
        handle = urlMatch && urlMatch[1] ? urlMatch[1] : null;
        
        if (!handle) throw new Error('Could not extract handle');
        product = await fetchProduct(handle);
      }

      // Format price (Shopify prices are in cents)
      const price = (product.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: Shopify.currency.active
      });
      
      const comparePrice = product.compare_at_price
        ? (product.compare_at_price / 100).toLocaleString(undefined, {
            style: 'currency',
            currency: Shopify.currency.active
          })
        : null;
      
      // Get first available image
      const img = (product.images && product.images.length)
        ? product.images[0]
        : (product.featured_image || '');

      // Render product card
      el.outerHTML = `
        <div class="blog-product-card">
          <a class="blog-product-card__img" href="${product.url}">
            ${img ? `<img src="${img}" alt="${product.title}">` : ''}
          </a>
          <div class="blog-product-card__content">
            <h3 class="blog-product-card__title">${product.title}</h3>
            ${product.vendor ? `<p class="blog-product-card__vendor">${product.vendor}</p>` : ''}
            <p class="blog-product-card__price">
              ${price} ${comparePrice ? `<s style="opacity:.6;margin-left:8px">${comparePrice}</s>` : ''}
            </p>
            <a href="${product.url}" class="blog-product-card__btn">${window.i18n?.blogArticle?.viewProduct}</a>
          </div>
        </div>`;
    } catch (e) {
      // Show error message if product not found
      el.outerHTML = `
        <p style="text-align:center;border:1px dashed #ddd;padding:14px;border-radius:8px">
          Produit introuvable pour <code>${raw}</code>. Utilisez le handle ou l'URL de produit.
        </p>`;
    }
  });
})();
